import { render, staticRenderFns } from "./PrintInfectionsStatusModal.vue?vue&type=template&id=550f7174"
import script from "./PrintInfectionsStatusModal.vue?vue&type=script&lang=ts"
export * from "./PrintInfectionsStatusModal.vue?vue&type=script&lang=ts"
import style0 from "./PrintInfectionsStatusModal.vue?vue&type=style&index=0&id=550f7174&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports